const paths = {
  whatsapp: '/whatsapp'
};

export default paths;
